import { AdditionalData } from '@monkvision/types';

export enum HagertyInspectionStatus {
  INSPECTION_LINK_SEND = 'inspection_link_send',
  ONGOING_CAPTURE = 'ongoing_capture',
  READY_FOR_REVIEW = 'ready_for_review',
  PDF_SENT = 'pdf_sent',
  FINALIZED = 'finalized',
}

export interface HagertyAdditionalData extends AdditionalData {
  customer_status?: HagertyInspectionStatus;
  last_update_date?: string; // ISO 8601
  inspection_start?: string; // ISO 8601
  inspection_end?: string; // ISO 8601
}
